import { SelectionColumnDef } from 'ag-grid-community';

/**
 * Fixed-width, non-sortable settings for the grid's built-in checkbox selection column
 * (`gridOptions.selectionColumnDef`), matching the checkbox columns we defined ourselves before ag-grid 32.2.
 */
export function checkboxSelectionColumnDef(width = 40, pinned?: 'left'): SelectionColumnDef {
  return {
    width,
    minWidth: width,
    maxWidth: width,
    resizable: false,
    sortable: false,
    suppressHeaderMenuButton: true,
    ...(pinned ? { pinned } : {}),
  };
}
